/* eb-gallery-carousel.js (Tim 2026-06-16; geo-shipping 2026-06-17) — Enoch LP enhancements, self-contained, degrades gracefully:
   (1) hero gallery -> swipe/scroll carousel; (2) mobile gallery->buybox gap trim;
   (3) Format & Specs + Shipping & Delivery accordion copy (Acutrack: ships 24h, US 3-6 days);
   (4) '24h ship' speed badge under the buy button;
   (5) removes the 'Sample reviews for layout' placeholder warning;
   (6) drawer button hover/cursor states (so each button reads as clickable);
   (7) GEO-ADAPTIVE shipping copy: US visitors keep "Free U.S. shipping"; everyone
       else sees "Ships worldwide / tracked at checkout" (badge, accordion, buy-box
       subtrust, announce bar, final CTA) + non-US "Printed in the USA" -> "Printed to order".
       One cached ipapi lookup; US is the graceful default if geo can't be resolved.
   Loaded via enoch-story.liquid. */
(function(){
  var DONE=false, COPYDONE=false, EB_ISUS=null, EB_GEO_DONE=false;
  function gapCss(){
    if(document.getElementById('eb-gap-css'))return;
    var s=document.createElement('style');s.id='eb-gap-css';
    s.textContent='@media(max-width:749px){#eb-product .eb-herogrid{gap:16px!important}#eb-product .eb-gallery{margin-bottom:0!important}}';
    document.head.appendChild(s);
  }
  function carCss(){
    if(document.getElementById('eb-gcar-css'))return;
    var s=document.createElement('style');s.id='eb-gcar-css';
    s.textContent='#eb-product .eb-gframe.eb-gcar{position:relative!important;display:flex!important;flex-wrap:nowrap!important;overflow-x:auto!important;overflow-y:hidden!important;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding:0!important;height:auto!important;aspect-ratio:1/1;cursor:grab;scrollbar-width:none;touch-action:pan-x pan-y}#eb-product .eb-gframe.eb-gcar::-webkit-scrollbar{display:none}#eb-product .eb-gframe.eb-gcar .eb-gslide{flex:0 0 100%!important;width:100%!important;height:auto!important;aspect-ratio:1/1;scroll-snap-align:center;position:relative;background:#0B1B40}#eb-product .eb-gframe.eb-gcar .eb-gslide img{position:absolute;inset:0;width:100%!important;height:100%!important;object-fit:contain!important;margin:0;padding:0;border:0;display:block;pointer-events:none}';
    document.head.appendChild(s);
  }
  function build(){
    if(DONE)return;
    gapCss();
    try{
      var gallery=document.querySelector('#eb-product .eb-gallery')||document.querySelector('.eb-gallery');
      if(!gallery)return;
      var gframe=gallery.querySelector('.eb-gframe');
      var thumbsWrap=gallery.querySelector('.eb-thumbs');
      if(!gframe||!thumbsWrap)return;
      var thumbs=[].slice.call(thumbsWrap.querySelectorAll('.eb-gthumb'));
      var urls=thumbs.map(function(t){return t.getAttribute('data-full');}).filter(Boolean);
      if(urls.length<2)return;
      /* The gallery keeps 1200px data-full URLs for the lightbox, but the carousel
         should not download a 1200px square for a ~348px mobile slot. Select the
         nearest Shopify CDN width for the rendered gallery and cap raster density at
         2x; this preserves a crisp swipe gallery while removing the largest first-load
         image waste on the Enoch and 88-book product funnels. */
      function slideUrl(u){
        var cssW=Math.max(320,Math.round(gallery.getBoundingClientRect().width||gallery.clientWidth||360));
        var need=cssW*Math.min(2,Math.max(1,window.devicePixelRatio||1));
        var widths=[360,480,640,750,900,1050,1200],chosen=1200;
        for(var wi=0;wi<widths.length;wi++){if(widths[wi]>=need){chosen=widths[wi];break;}}
        return /([?&])width=\d+/.test(u)?u.replace(/([?&])width=\d+/,'$1width='+chosen):u+(u.indexOf('?')>-1?'&':'?')+'width='+chosen;
      }
      DONE=true;
      carCss();
      var car=document.createElement('div');
      car.className='eb-gframe eb-gcar';car.setAttribute('data-car','1');
      urls.forEach(function(u,i){
        var sl=document.createElement('div');sl.className='eb-gslide';
        var im=document.createElement('img');
        /* Only the first slide belongs to the critical rendering path. Native `loading=lazy`
           was ineffective here because every absolutely-positioned slide shares the hero's
           above-fold geometry, so Chrome fetched the full gallery immediately. Keep the
           remaining URLs inert until a slide approaches the carousel or the shopper selects it. */
        var su=slideUrl(u);
        if(i===0){im.src=su;}else{im.setAttribute('data-src',su);}
        im.loading=i===0?'eager':'lazy';im.decoding='async';im.alt='';
        sl.appendChild(im);car.appendChild(sl);
      });
      gframe.parentNode.replaceChild(car,gframe);
      function arm(i){
        var sl=car.children[i],im=sl&&sl.querySelector('img[data-src]');
        if(im){im.src=im.getAttribute('data-src');im.removeAttribute('data-src');}
      }
      function watchSlides(){
        /* Wait until the injected flex-carousel CSS has been laid out before observing.
           Observing in the same task as replaceChild() lets Chromium briefly treat every
           slide as sharing the first slide's geometry, which marks the whole gallery as
           intersecting and defeats the data-src deferral. */
        void car.offsetWidth;
        arm(0);arm(1);
        if('IntersectionObserver' in window){
          var slideIo=new IntersectionObserver(function(entries){
            entries.forEach(function(e){if(e.isIntersecting)arm([].indexOf.call(car.children,e.target));});
          },{root:car,rootMargin:'0px 35%',threshold:0.01});
          [].forEach.call(car.children,function(sl){slideIo.observe(sl);});
        }else{
          urls.forEach(function(_,i){arm(i);});
        }
      }
      if(window.requestAnimationFrame){
        requestAnimationFrame(function(){requestAnimationFrame(watchSlides);});
      }else{
        setTimeout(watchSlides,0);
      }
      function setActive(i){thumbs.forEach(function(t,j){t.classList.toggle('eb-active',j===i);});}
      window.ebSwapHero=function(el){var t=el&&el.classList&&el.classList.contains('eb-gthumb')?el:(el&&el.closest?el.closest('.eb-gthumb'):null);var i=thumbs.indexOf(t);if(i>=0){arm(i);var sl=car.children[i];if(sl)car.scrollTo({left:sl.offsetLeft,behavior:'smooth'});setActive(i);}};
      var to;
      car.addEventListener('scroll',function(){clearTimeout(to);to=setTimeout(function(){var w=Math.max(1,car.clientWidth);var i=Math.round(car.scrollLeft/w);i=Math.max(0,Math.min(thumbs.length-1,i));arm(i);arm(Math.min(thumbs.length-1,i+1));arm(Math.max(0,i-1));setActive(i);var t=thumbs[i];if(t&&t.scrollIntoView)t.scrollIntoView({inline:'center',block:'nearest',behavior:'smooth'});},90);},{passive:true});
      var down=false,sx=0,start=0;
      car.addEventListener('mousedown',function(e){down=true;sx=e.pageX;start=car.scrollLeft;car.style.cursor='grabbing';e.preventDefault();});
      window.addEventListener('mousemove',function(e){if(!down)return;car.scrollLeft=start-(e.pageX-sx);});
      window.addEventListener('mouseup',function(){if(!down)return;down=false;car.style.cursor='grab';var w=Math.max(1,car.clientWidth);var i=Math.round(car.scrollLeft/w);car.scrollTo({left:i*w,behavior:'smooth'});});
    }catch(e){}
  }
  function patchCopy(){
    if(COPYDONE)return;
    try{
      var accs=document.querySelectorAll('#eb-product .en-acc');
      if(!accs.length)return;
      var hit=false;
      [].forEach.call(accs,function(acc){
        var hd=acc.querySelector('.en-acc-hd'); if(!hd)return;
        var t=(hd.textContent||'').trim();
        var ul=acc.querySelector('.en-acc-list'); if(!ul)return;
        if(t.indexOf('Format')===0){
          ul.innerHTML='<li><b>Large 7″ × 10″ format</b> — generous, easy-to-read type (no squinting)</li><li><b>320+ pages</b> — premium printed &amp; bound edition</li><li><b>Premium soft-touch paperback</b> — matte cover, built to last</li><li><b>Companion eBook</b> (ePub + PDF) — read on any device, instantly</li><li><b>Full audiobook narration</b> — listen anywhere, free</li>';
          hit=true;
        } else if(t.indexOf('Shipping')===0){
          if(EB_ISUS===false){
            ul.innerHTML='<li><b>Instant digital access</b> — eBook, PDF &amp; audiobook in your inbox seconds after checkout (start tonight)</li><li><b>Ships worldwide, fully tracked</b> — printed to order, regionally where possible to cut customs delays</li><li><b>International delivery: typically 10–18 business days</b></li><li><b>Tracked shipping calculated at checkout</b> by destination</li>';
          } else {
            ul.innerHTML='<li><b>Instant digital access</b> — eBook, PDF &amp; audiobook in your inbox seconds after checkout (start tonight)</li><li><b>Printed to order in the USA</b> — free &amp; fully tracked</li><li><b>US delivery: typically 5–8 business days</b></li><li><b>International: typically 10–18 business days</b> — printed regionally where possible to cut customs delays</li>';
          }
          hit=true;
        }
      });
      if(hit)COPYDONE=true;
    }catch(e){}
  }
  function shipBadge(){
    if(document.getElementById('eb-ship24'))return;
    try{
      var cta=document.querySelector('#eb-product [data-eb-cta]');
      if(!cta||!cta.parentNode)return;
      var el=document.createElement('div');el.id='eb-ship24';
      el.innerHTML=badgeHtml();
      el.style.cssText='text-align:center;font-size:13.5px;line-height:1.45;color:#0B1B40;background:rgba(201,162,74,.12);border:1px solid rgba(201,162,74,.4);border-radius:9px;padding:9px 12px;margin:10px 0 0;font-weight:500';
      var _t=ebTier(); var _free=(_t==='US'||_t==='GB'||_t==='CA'||_t==='AU'||_t==='EU'); if(window.EB_FUNNEL==='ethbible' && _free){ el.style.margin='0 0 10px'; cta.parentNode.insertBefore(el,cta); } else { cta.parentNode.insertBefore(el,cta.nextSibling); }
    }catch(e){}
  }
  function ebTier(){ try{ if(window.EBGeo&&typeof EBGeo.copyTier==='function'){ var t=EBGeo.copyTier(); if(t) return t; } }catch(e){} try{ if(window.EBGeo&&window.EBGeo.tierOf){ var g=JSON.parse(sessionStorage.getItem('eb_geo')||'null'); return window.EBGeo.tierOf((g&&g.cc)||''); } }catch(e){} return (EB_ISUS===false)?'ROW':'US'; }
  function badgeHtml(){
    var t=ebTier();
    if(t==='GB') return '🚚 <b>Free UK shipping</b> · printed in the UK · fully tracked';
    if(t==='CA') return '🚚 <b>Free Canadian shipping</b> · printed in Canada · fully tracked';
    if(t==='AU') return '🚚 <b>Free Australian shipping</b> · printed in Australia · fully tracked';
    if(t==='EU') return '🚚 <b>Free EU shipping</b> · printed in the EU · fully tracked';
    if(t==='ROW') return '🚚 <b>Ships worldwide</b> · tracked · shipping calculated at checkout';
    return '🚚 <b>Free US shipping</b> · printed to order in the USA · fully tracked';
  }
  /* ---- Geo-adaptive shipping copy ---- */
  function geoResolve(){
    if(EB_GEO_DONE)return;
    function done(isus){ EB_ISUS=(isus===true)?true:(isus===false?false:null); EB_GEO_DONE=true; applyGeo(); }
    if(window.EBGeo&&window.EBGeo.get){ window.EBGeo.get(function(g){ done(g?g.isUS:null); }); return; }
    var c=null; try{c=sessionStorage.getItem('eb_isus');}catch(e){}
    if(c==='1'){done(true);return;} if(c==='0'){done(false);return;}
    try{
      fetch('https://ipapi.co/json/').then(function(r){return r.json();}).then(function(g){
        var us=!!(g&&g.country_code==='US'); try{sessionStorage.setItem('eb_isus',us?'1':'0');}catch(e){} done(us);
      }).catch(function(){EB_GEO_DONE=true;});
    }catch(e){EB_GEO_DONE=true;}
  }
  function sweepIntl(){
    // Rewrite single-text-node US-centric phrases (Liquid-rendered: hero subtrust,
    // announce bar, final CTA price line + reassure). Non-US only.
    var swaps=[
      [' to order in the USA',' to order'],
      ['Ships free (U.S.), fully tracked','Ships worldwide · tracked'],
      ['ships free (U.S.), fully tracked','ships worldwide, fully tracked'],
      ['Ships free (U.S.)','Ships worldwide · tracked'],
      ['ships free (U.S.)','ships worldwide, tracked'],
      ['Free U.S. Shipping','Ships Worldwide · Tracked'],
      ['Free US shipping','Ships worldwide · tracked'],
      ['Free U.S. shipping','Ships worldwide · tracked'],
      ['free U.S. shipping','worldwide shipping'],
      ['free US shipping','worldwide shipping'],
      ['Printed & shipped in the USA','Printed to order · ships worldwide'],
      ['printed & shipped from the USA','printed to order, ships worldwide'],
      ['Printed in the USA','Printed to order'],
      ['printed in the USA','printed to order']
    ];
    try{
      var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null,false),n;
      while(n=w.nextNode()){
        var v=n.nodeValue; if(!v||v.length<6)continue; var nv=v;
        for(var i=0;i<swaps.length;i++){ if(nv.indexOf(swaps[i][0])>-1) nv=nv.split(swaps[i][0]).join(swaps[i][1]); }
        if(nv!==v)n.nodeValue=nv;
      }
    }catch(e){}
  }
  function applyGeo(){
    var b=document.getElementById('eb-ship24'); if(b)b.innerHTML=badgeHtml();
    if(EB_ISUS!==false)return; // FAQ copy block below only swaps for confirmed non-US
    COPYDONE=false; patchCopy();   // re-render the Shipping accordion as intl
    sweepIntl();                   // swap the Liquid-rendered phrases
  }
  function killDisc(){
    try{
      var all=document.querySelectorAll('body *'),match=null,best=1e9;
      for(var i=0;i<all.length;i++){var tc=all[i].textContent||'';if(tc.indexOf('Sample reviews for layout')>-1&&tc.length<best){best=tc.length;match=all[i];}}
      if(match)match.remove();
    }catch(e){}
  }
  function drawerHoverCss(){
    if(document.getElementById('eb-drawer-hover'))return;
    var s=document.createElement('style');s.id='eb-drawer-hover';
    s.textContent='#eb-drawer button,#eb-drawer .ebd-prot,#eb-drawer .ebd-protect,#eb-drawer label{cursor:pointer}#eb-drawer button,#eb-drawer .ebd-add,#eb-drawer .ebd-checkout,#eb-drawer .ebd-add2 button{transition:background .15s,border-color .15s,color .15s,transform .12s,box-shadow .15s,filter .15s}#eb-drawer .ebd-add:hover,#eb-drawer .ebd-checkout:hover{filter:brightness(1.08);transform:translateY(-1px);box-shadow:0 7px 18px rgba(0,20,79,.22)}#eb-drawer .ebd-add2 button:hover{background:var(--gold);border-color:var(--gold);color:#00144F}#eb-drawer .ebd-qty button:hover,#eb-drawer .ebd-x:hover{background:rgba(0,20,79,.09)}#eb-drawer .ebd-add:active,#eb-drawer .ebd-checkout:active,#eb-drawer .ebd-add2 button:active{transform:translateY(0)}';
    document.head.appendChild(s);
  }
  function go(){build();patchCopy();shipBadge();killDisc();drawerHoverCss();geoResolve();if(EB_GEO_DONE&&EB_ISUS===false)applyGeo();}
  if(document.readyState==='complete')go();
  else{document.addEventListener('DOMContentLoaded',go);window.addEventListener('load',go);}
  setTimeout(go,500);setTimeout(go,1500);
})();
